import { useConfirmEmailChange } from '@myrentalmate/api-client';
import { Alert, Button, Paper, Stack, Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router';

import { okData } from '../../lib/apiData';
import { useFragmentToken } from '../../lib/useFragmentToken';

/**
 * /account/confirm-email#<token>, behind sign-in, so only the person who asked can finish it. A
 * click is required because email security scanners open links automatically.
 */
export function ConfirmEmailPage() {
  const token = useFragmentToken();
  const queryClient = useQueryClient();
  const confirm = useConfirmEmailChange({
    mutation: { onSuccess: () => queryClient.invalidateQueries() },
  });
  const message = okData(confirm.data)?.message;

  return (
    <Paper variant="outlined" sx={{ p: 3, maxWidth: 560 }}>
      <Stack spacing={2} sx={{ alignItems: 'flex-start' }}>
        <Typography variant="h5">Confirm Your New Email</Typography>
        {message ? (
          <>
            <Alert severity="success">{message}</Alert>
            <Button component={Link} to="/account">
              Back to my profile
            </Button>
          </>
        ) : !token || confirm.isError ? (
          <>
            <Alert severity="error">
              This link isn't valid. It may have expired, been used already, or belong to a
              different account.
            </Alert>
            <Button component={Link} to="/account">
              Back to my profile
            </Button>
          </>
        ) : (
          <Button
            variant="contained"
            disabled={confirm.isPending}
            onClick={() => confirm.mutate({ data: { token } })}
          >
            {confirm.isPending ? 'Confirming…' : 'Use this email'}
          </Button>
        )}
      </Stack>
    </Paper>
  );
}
